import leapfrog from '../elements/leapfrog.js';
leapfrog.register();
